import { forwardRef } from "react"
import { Input, Label } from "@ui/shad"
import { cn } from "@ui/utils"

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string
  label?: string
  error?: boolean
  helperText?: string
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ label, error, id, helperText, ...props }, ref) => {
    return (
      <div className="space-y-0.5">
        {label && (
          <Label htmlFor={id} className={cn(error && "text-destructive")}>
            {label}
          </Label>
        )}
        <Input ref={ref} id={id} className={cn(error && "border-destructive")} {...props} />
        {helperText && <p className="text-muted-foreground text-xs">{helperText}</p>}
      </div>
    )
  }
)

TextInput.displayName = "TextInput"
